import React from 'react'
import Headerbar  from "./components/common/Headerbar";
import Titlebar  from "./components/common/Titlebar";
import Vendorlistgrid from './components/payment_approval/Vendorlistgrid';

function Vendors() {
  return (
    <><Headerbar /><Titlebar name="Vendors Listing" /><Vendorlistgrid/></>
  )
}

export default Vendors